import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import CurrencyInput from '../../generic/CurrencyInput';
import { billableBudgetShape } from '../../prop-types';

function BillableBudget({ billableBudgets }) {
  const {
    billableBudgetMediaExternal,
    billableBudgetMediaInternal,
    billableBudgetMediaWKZ,
    billableBudgetCreativeExternal,
    billableBudgetCreativeInternal,
    billableBudgetCreativeWKZ,
    billableBudgetCIExternal,
    billableBudgetCIInternal,
    billableBudgetCIWKZ,
    billableBudgetOtherExternal,
    billableBudgetOtherInternal,
    billableBudgetOtherWKZ,
  } = billableBudgets;
  return (
    <>
      <h4>Billable Budget</h4>
      <FormGroup row>
        <Label sm={3}>Media</Label>
        <Col sm={9} className="d-flex">
          <div className="d-inline-block mr-2">
            External
            <br />
            <CurrencyInput
              id="bb-billableBudgetMediaExternal"
              name="billableBudgetMediaExternal"
              value={billableBudgetMediaExternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            Internal
            <br />
            <CurrencyInput
              id="bb-billableBudgetMediaInternal"
              name="billableBudgetMediaInternal"
              value={billableBudgetMediaInternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            WKZ
            <br />
            <CurrencyInput
              id="bb-billableBudgetMediaWKZ"
              name="billableBudgetMediaWKZ"
              value={billableBudgetMediaWKZ}
              readOnly
            />
          </div>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={3}>Creative</Label>
        <Col sm={9} className="d-flex">
          <div className="d-inline-block mr-2">
            External
            <br />
            <CurrencyInput
              id="bb-billableBudgetCreativeExternal"
              name="billableBudgetCreativeExternal"
              value={billableBudgetCreativeExternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            Internal
            <br />
            <CurrencyInput
              id="bb-billableBudgetCreativeInternal"
              name="billableBudgetCreativeInternal"
              value={billableBudgetCreativeInternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            WKZ
            <br />
            <CurrencyInput
              id="bb-billableBudgetCreativeWKZ"
              name="billableBudgetCreativeWKZ"
              value={billableBudgetCreativeWKZ}
              readOnly
            />
          </div>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={3}>CI</Label>
        <Col sm={9} className="d-flex">
          <div className="d-inline-block mr-2">
            External
            <br />
            <CurrencyInput
              id="bb-billableBudgetCIExternal"
              name="billableBudgetCIExternal"
              value={billableBudgetCIExternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            Internal
            <br />
            <CurrencyInput
              id="bb-billableBudgetCIInternal"
              name="billableBudgetCIInternal"
              value={billableBudgetCIInternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            WKZ
            <br />
            <CurrencyInput
              id="bb-billableBudgetCIWKZ"
              name="billableBudgetCIWKZ"
              value={billableBudgetCIWKZ}
              readOnly
            />
          </div>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={3}>Other</Label>
        <Col sm={9} className="d-flex">
          <div className="d-inline-block mr-2">
            External
            <br />
            <CurrencyInput
              id="bb-billableBudgetOtherExternal"
              name="billableBudgetOtherExternal"
              value={billableBudgetOtherExternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            Internal
            <br />
            <CurrencyInput
              id="bb-billableBudgetOtherInternal"
              name="billableBudgetOtherInternal"
              value={billableBudgetOtherInternal}
              readOnly
            />
          </div>
          <div className="d-inline-block mr-2">
            WKZ
            <br />
            <CurrencyInput
              id="bb-billableBudgetOtherWKZ"
              name="billableBudgetOtherWKZ"
              value={billableBudgetOtherWKZ}
              readOnly
            />
          </div>
        </Col>
      </FormGroup>
    </>
  );
}

BillableBudget.propTypes = {
  billableBudgets: billableBudgetShape.isRequired,
};

export default BillableBudget;
